import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { SettingsSiteControllerTemairazuMainSection } from "./section";
import { SettingsSiteControllerBase } from "../../_shared/base";

import type { SiteControllerSettingBaseFormModel } from "../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingTemairazuFormModel } from "../../../../model/temairazu/type";
import type { SiteControllerSettingTemairazuFormModelMethodsType } from "../../../../model/temairazu/use-case/use-create-model/methods";

type Props = {
	hotelID: string;
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	temairazuViewModel: SiteControllerSettingTemairazuFormModel["ViewModel"];
	siteControllerSettingTemairazuFormModelMethodsType: SiteControllerSettingTemairazuFormModelMethodsType;
};

export const SettingsSiteControllerTemairazuMain = ({
	hotelID,
	baseViewModel,
	siteControllerSettingBaseFormModelMethodsType, //

	temairazuViewModel,
	siteControllerSettingTemairazuFormModelMethodsType,
}: Props) => {
	return (
		<FeatureIslandMainWithBackGround>
			<SettingsSiteControllerBase
				hotelID={hotelID}
				siteControllerType={baseViewModel.siteControllerType}
				siteControllerSettingBaseFormModelMethods={siteControllerSettingBaseFormModelMethodsType}
			/>
			<SettingsSiteControllerTemairazuMainSection
				siteControllerSettingTemairazuFormModelMethodsType={siteControllerSettingTemairazuFormModelMethodsType}
				temairazuViewModel={temairazuViewModel}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

SettingsSiteControllerTemairazuMain.displayName = "SettingsSiteControllerTemairazuMain";
